// removed by extract-text-webpack-plugin
module.exports = {"container":"index__container___K62ye","logo":"index__logo___Vj_3B"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Header/index.css
// module id = 830
// module chunks = 0